export const ZONE_DATA = {
  "1A": "1A",
  "1B": "1B",
  "1C": "1C",
  "1D": "1D",
  "2A": "2A",
  "2B": "2B",
  "3A": "3A",
  "3B": "3B",
  "4A": "4A",
  "4B": "4B",
  "4C": "4C",
  "4D": "4D",
  "5A": "5A",
  "5B": "5B",
  "5C": "5C",
  "5D": "5D",
  "6A": "6A",
  "6B": "6B",
  "6C": "6C",
  "A1": "A1",
  J1: "J1",
  J2: "J2",
  J3: "J3",
  J4: "J4",
  J5: "J5",
  L1: "L1",
  CLUB: "CLUB",
};

export const STALL_DESIGN_DATA = {
  ONESIDE_OPENSTALL: "One Side Open Stall",
  TWOSIDE_OPENSTALL: "Two Side Open Stall",
  THREESIDE_OPENSTALL: "Three Side Open Stall",
  FOURSIDE_OPENSTALL: "Four Side Open Stall",
};

export const PREMIUM_TYPE_DATA = {
  ONESIDE_OPENSTALL: "One Side Open Stall",
  TWOSIDE_OPENSTALL: "Two Side Open Stall",
  THREESIDE_OPENSTALL: "Three Side Open Stall",
  // FOURSIDE_OPENSTALL: "Four Side Open Stall",
  PREMIUM: "Premium",
};

export const VENDOR_DATA = {
  vendor1: {
    name: "9958091702",
    phone: "9958091702",
  },
  vendor2: {
    name: "Pavilions N Interiors",
    phone: "7290060797",
  },
  vendor3: {
    name: "N K Kapur",
    phone: "9711130877",
  },
  vendor4: {
    name: "Expro Events",
    phone: "9958091702",
  },
  vendor5: {
    name: "Pnim",
    phone: "8376090406",
  },
  vendor6: {
    name: "Balaji Exim - The Select Club",
    phone: "8010002221",
  },
  vendor7: {
    name: "Balaji - Machinery",
    phone: "9311285025",
  },
  vendor8: {
    name: "9310502225",
    phone: "9310502225",
  },
};

export const STALL_SIDE_TYPE = {
  GENERAL: 0,
  LHS: 1,
  RHS: 2
}

export const PRIME_TYPE = {
  'Yes': 'Yes',
  'No': 'No'
}

export const PRIME_ASSURE_TYPE = {
  'Yes': "Yes",
  'No': 'No'
}

export const getVendorKeyByName = (vendorName) => {
  if (!vendorName) {
    return
  }
  const name = vendorName.toLowerCase();

  return (
    Object.entries(VENDOR_DATA).find(
      ([_, vendor]) => vendor.name.toLowerCase() === name
    )?.[0] || null
  );
};

export const getKeyByValue = (obj, value) => {
  return Object.keys(obj).find(key => obj[key] === value);
};